import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { RegisterProxyService } from './register-proxy.service';
import { UploadImageProxyService } from './upload-image-proxy.service';

import { AccountServicesModule } from '../../account-services.module';

import { RegisterAccountDto, UpdateAccountDto, ChangePasswordDto, ChangeCountyDto, SendPasswordResetCodeDto } from '../models/register-models';
import { WebApiResponse } from 'src/app/core/api/models/api-model';

@Injectable({
	providedIn: AccountServicesModule
})
export class AccountService {

	constructor(
		private registerProxy: RegisterProxyService,
		private uploadImageProxy: UploadImageProxyService) { }

	registerAccount(registerAccountDto: RegisterAccountDto): Observable<WebApiResponse<any>> {
		return this.registerProxy.registerAccount(registerAccountDto);
	}

	updateAccount(registerAccountDto: UpdateAccountDto) {
		return this.registerProxy.updateAccount(registerAccountDto);
	}

	changePassword(changePasswordDto: ChangePasswordDto) {
		return this.registerProxy.changePassword(changePasswordDto);
	}

	changeCounty(changeCountyDto: ChangeCountyDto): Observable<WebApiResponse<any>> {
		return this.registerProxy.changeCounty(changeCountyDto);
	}

	getAccount() {
		return this.registerProxy.getAccount();
	}

	getUploadProfilePictureUrl() {
		return this.uploadImageProxy.getUploadProfilePictureUrl();
	}

	getProfilePicture() {
		return this.uploadImageProxy.getProfilePicture();
	}

	sendPasswordResetCode(sendPasswordResetCodeDto: SendPasswordResetCodeDto): Observable<WebApiResponse<void>> {
		return this.registerProxy.sendPasswordResetCode(sendPasswordResetCodeDto);
	}


}
